import React, { useState, Fragment, useEffect } from 'react';
import { Button } from '@cityelectricalfactors/ui-components';
import { useHTTP } from 'hooks/useRequest';
import { InfoIcon, UserIcon } from '../../../../assets/common_svgs';

const ApprovalsUnassignedUsers = ({ unassignedUsers }) => {
  const [showUsers, setShowUsers] = useState(false);
  const [submitRequest, setSubmitRequest] = useState(false);
  const [users, setUsers] = useState(unassignedUsers);

  const toggleHandler = () => {
    setShowUsers(prev => !prev);
  };

  const { data } = useHTTP({
    method: 'GET',
    url: submitRequest ? '/mycef/approval_groups' : null,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });

  // Note: The following are used to send a request for users if no
  // unassignedUsers instance variable has been passed to component.
  useEffect(() => {
    if (typeof users === 'undefined') {
      setSubmitRequest(true);
    }
  }, []);

  useEffect(() => {
    if (data) {
      setUsers(data.unassigned_users);
      setSubmitRequest(false);
    }
  }, [data]);

  // The response on the group listing page will be undefined onLoad due to no instance variable.
  // The response on the user listing page will be true even if the total number of users is 0.
  const showUnassignedUsers =
    typeof users !== 'undefined' && users.total_users !== 0;

  return (
    <>
      {showUnassignedUsers && (
        <div className="unassigned-users mt-16 ptb-12 pl-18 pr-14">
          <div className="fl ai-c">
            <UserIcon fillColor="#999999" width={25} height={25} />
            <p className="ff-r fs-16 tc-grey-70 mb-0 ml-12">
              <span className="fw-500">{users.total_users} users</span> are not
              assigned to an order approvals group
            </p>
            <Button
              handleClick={toggleHandler}
              className="unassigned-users__btn cef-btn cef-btn--grey ml-auto">
              {`${showUsers ? 'Hide' : 'View'} Users`}
            </Button>
          </div>
          {showUsers && (
            <div className="unassigned-users__text-wrapper ml-35">
              <p className="mb-0 fs-16">
                {users.users.map(({ id, path, forename, surname }, index) => (
                  <Fragment key={id}>
                    <a href={path} className="unassigned-users__link">
                      {`${forename} ${surname}`}
                    </a>
                    {index < users.users.length - 1 && ', '}
                  </Fragment>
                ))}
              </p>
            </div>
          )}
        </div>
      )}
      <div className="fl mt-16 mb-5">
        <div>
          <InfoIcon fillColor="#EAC80C" width={24} height={24} />
        </div>
        <p className="ml-10 mb-0 mt-2 ff-r fs-16 tc-grey-70 lh-1-3">
          <span className="fw-500">
            We recommend adding all users to an Order Approval Group.
          </span>{' '}
          The account administrator will receive order approval requests for all
          users not assigned to a group.
        </p>
      </div>
    </>
  );
};

export default ApprovalsUnassignedUsers;
